<div class="noselect total-price ws-product-detail__total">
  <span [translate]="'common.total'">
    Total
  </span>&nbsp;<strong class="ws-product-detail__total-value">
    {{(totalPrice + extraPrice) | currencyFormat}}
  </strong>&nbsp;{{currency}}
</div>
